module.exports = __webpack_public_path__ + "img/sdg8_jp.9b77d11c.png";